module.exports = __webpack_public_path__ + "static/img/telegram-guide-img.4ec270e.png";